import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.object.define-properties";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
import { pxToRem } from './utils';
import defaultConfig, { spaceApiPropNames } from './config';
var keys = Object.keys;

var sizeModifierFactory = function sizeModifierFactory(_ref) {
  var base = _ref.base,
      scale = _ref.scale,
      sizeSymbols = _ref.sizeSymbols;
  var scaleFunctions = {
    tshirt: function tshirt() {
      var factors = [0.125, 0.25, 0.5, 0.75, 1, 1.5, 2, 2.5, 4];
      var obj = {};
      sizeSymbols.forEach(function (key, index) {
        obj[key] = pxToRem(base * factors[index]);
      });
      return obj;
    }
  };
  return scaleFunctions[scale]();
};

export var createPropValues = function createPropValues() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$base = _ref2.base,
      base = _ref2$base === void 0 ? 16 : _ref2$base,
      _ref2$scale = _ref2.scale,
      scale = _ref2$scale === void 0 ? 'tshirt' : _ref2$scale,
      _ref2$types = _ref2.types,
      types = _ref2$types === void 0 ? defaultConfig.types : _ref2$types,
      _ref2$sizeSymbols = _ref2.sizeSymbols,
      sizeSymbols = _ref2$sizeSymbols === void 0 ? defaultConfig.sizeSymbols : _ref2$sizeSymbols,
      _ref2$typeModifiers = _ref2.typeModifiers,
      typeModifiers = _ref2$typeModifiers === void 0 ? defaultConfig.typeModifiers : _ref2$typeModifiers;

  var propValues = {};

  var sizeModifiers = _objectSpread({
    0: 0
  }, sizeModifierFactory({
    base: base,
    scale: scale,
    sizeSymbols: sizeSymbols
  }));

  keys(types).forEach(function (t) {
    keys(typeModifiers).forEach(function (tm) {
      keys(sizeModifiers).forEach(function (sm) {
        var key = t + tm + sm;
        var value = {};
        var tmVals = typeModifiers[tm];
        tmVals.forEach(function (tmv) {
          return value[types[t] + tmv] = sizeModifiers[sm];
        });
        propValues[key] = value;
      });
    });
  });
  return propValues;
};
export var flattenOperatorApi = function flattenOperatorApi(props) {
  return spaceApiPropNames.reduce(function (flatApi, propName) {
    var value = props[propName];

    if (typeof value !== 'undefined') {
      switch (String(value)) {
        case '0':
          flatApi["".concat(propName, "0")] = true;
          break;

        case 'xxxs':
          flatApi["".concat(propName, "1")] = true;
          break;

        case 'xxs':
          flatApi["".concat(propName, "2")] = true;
          break;

        case 'xs':
          flatApi["".concat(propName, "3")] = true;
          break;

        case 's':
          flatApi["".concat(propName, "4")] = true;
          break;

        case 'b':
          flatApi["".concat(propName, "5")] = true;
          break;

        case 'm':
          flatApi["".concat(propName, "6")] = true;
          break;

        case 'l':
          flatApi["".concat(propName, "7")] = true;
          break;

        case 'xl':
          flatApi["".concat(propName, "8")] = true;
          break;

        case 'xxl':
          flatApi["".concat(propName, "9")] = true;
          break;

        default:
          break;
      }
    }

    return flatApi;
  }, {});
};